export enum ListState {
	Default = 'Default',
	Loading = 'Loading',
	LastPage = 'LastPage',
	Finished = 'Finished'
}
